type IframeViewProps = {
  file: string;
  heightValue?: string;
  className?: string;
};

const IframeView = ({
  file,
  heightValue = "500px",
  className,
}: IframeViewProps) => {
  return (
    <iframe
      className={`${className ? className : "position-relative w-100"}`}
      src={file}
      style={{ height: heightValue }}
    />
  );
};

export default IframeView;
